var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1656_21699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10.4999V13.4999C13 13.7652 12.8946 14.0195 12.7071 14.207C12.5196 14.3946 12.2652 14.4999 12 14.4999H2.5C2.23478 14.4999 1.98043 14.3946 1.79289 14.207C1.60536 14.0195 1.5 13.7652 1.5 13.4999V3.99994C1.5 3.73473 1.60536 3.48037 1.79289 3.29284C1.98043 3.1053 2.23478 2.99994 2.5 2.99994H5.5M8.49988 9.99994L5.49988 10.5399L5.99988 7.49994L11.7299 1.78994C11.8228 1.69621 11.9334 1.62182 12.0553 1.57105C12.1772 1.52028 12.3079 1.49414 12.4399 1.49414C12.5719 1.49414 12.7026 1.52028 12.8245 1.57105C12.9463 1.62182 13.0569 1.69621 13.1499 1.78994L14.2099 2.84994C14.3036 2.9429 14.378 3.0535 14.4288 3.17536C14.4795 3.29722 14.5057 3.42793 14.5057 3.55994C14.5057 3.69195 14.4795 3.82266 14.4288 3.94452C14.378 4.06637 14.3036 4.17698 14.2099 4.26994L8.49988 9.99994Z",
    stroke: "#003D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1656_21699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/InProgress.ec7f0e894104df6edd25ecbbffcd72c3.svg";
export { ForwardRef as ReactComponent };